import React from 'react';
import './Spinner.css';
import { Modal } from 'react-bootstrap';

export default class Spinner extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            show: false,
            text: 'Cargando...'
        }
    }

    showSpinner = text => this.setState({show: true, text: text});

    hideSpinner = () => this.setState({show: false});

    render() {
        return (<>
            {
                this.state.show ?
                    <Modal
                        className="modal-container"
                        show={this.state.show}
                        onHide={this.hideSpinner}
                        backdrop="static"
                        keyboard={false}
                    >
                        <Modal.Body>
                            <div className="d-flex justify-content-center spinner">
                                <span>{this.state.text}</span>
                                <img className="imgSpinner" src="../logob.png" alt="manicomio" />
                            </div>
                        </Modal.Body>
                    </Modal> : <></>
            }
        </>)
    }
}
